import PropTypes from 'prop-types';
import AppWorkbenchEmptyState from '../../../../components/common/AppWorkbenchEmptyState';

const PendingListEmptyState = ({ emptyTitle, emptyDescription, actionLabel, onAction }) => (
	<div className='pending-list-empty-state'>
		<AppWorkbenchEmptyState
			emptyTitle={emptyTitle}
			emptyDescription={emptyDescription}
			emptyIcon='check-circle'
			actionLabel={actionLabel}
			onAction={onAction}
		/>
	</div>
);

PendingListEmptyState.propTypes = {
	emptyTitle: PropTypes.string.isRequired,
	emptyDescription: PropTypes.string.isRequired,
	actionLabel: PropTypes.string,
	onAction: PropTypes.func,
};

export default PendingListEmptyState;
